import React, { useRef } from 'react';
import Loader from '../common/Loader.jsx';
import Slider from 'react-slick';
import CarouselImage from '../common/CarouselImage.jsx';
import { NextArrow, PrevArrow } from '../common/SliderArrowButtons.jsx';
import PropTypes from 'prop-types';

const LoadingLineSkeleton = (props) => {
	const { options } = props;
	const slider = useRef();
	// Dynamically creates an array: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
	const data = Array.apply(null, new Array(16)).map((el, i)=>i);

	// Additional features to add into the slider options
	const features = {
		nextArrow: <NextArrow classLabel={'next-arrow-pad'} visible={false} />,
		prevArrow: <PrevArrow classLabel={'prev-arrow-pad'} visible={false} />
	};

	// Combine the options with the features
	const settings = { ...options, ...features };

	/**
	 * Creates a generic template slider
	 *
	 * @returns {unknown[]}
	 */
	const getProducts = () => {
		return data.map((value, key) => {
			return (
				<a key={key} className={'product-box'}>
					<div className={'product-area'}>
						<Loader/>
						<CarouselImage
							src={'https://media1.shmoop.com/images/homepage/default_wide_thumbnail-270x113.jpg'} />
					</div>
				</a>
			);
		});
	};

	return (
		<div className={'loading-box'}>
			<Slider ref={slider} {...settings}> { getProducts() }</Slider>
		</div>
	);
};

export default LoadingLineSkeleton;

LoadingLineSkeleton.propTypes = {
	options: PropTypes.object
};
